import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../style/Navbar.css';
import { FaBars, FaTimes, FaPhoneAlt } from "react-icons/fa";
import { IoTimeOutline } from "react-icons/io5";
import { IoIosMail } from "react-icons/io";

import logo from '../assets/images/logo1.png';

const Navbar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div>
      <nav className="navbar">
        <div className="navbar-logo">
          <img src={logo} alt="JETA GROUPE" />
        </div>
        <div className="navbar-links">
          <Link to="/" onClick={() => scrollToSection('accueil')}>Accueil</Link>
          <Link to="/" onClick={() => scrollToSection('qui-sommes-nous')}>Qui Sommes nous?</Link>
          <Link to="/" onClick={() => scrollToSection('nos-societes')}>Nos sociétés</Link>
          <Link to="/" onClick={() => scrollToSection('contact')}>Contact</Link>
        </div>
        <div className="navbar-icon" onClick={toggleSidebar}>
          {sidebarOpen ? <FaTimes /> : <FaBars />}
        </div>
      </nav>
      {sidebarOpen && (
        <div className="sidebar">
          <div className="sidebar-close" onClick={toggleSidebar}>
            <FaTimes />
          </div>
          <div className="sidebar-content">
            <h1>JETA GROUPE</h1>
            <div className="sidebar-links">
                <Link to="/" onClick={() => scrollToSection('accueil')}>Accueil</Link>
                <Link to="/" onClick={() => scrollToSection('qui-sommes-nous')}>Qui Sommes nous?</Link>
                <Link to="/" onClick={() => scrollToSection('nos-societes')}>Nos sociétés</Link>
                <Link to="/" onClick={() => scrollToSection('contact')}>Contact</Link>
            </div>
            <p>Nous sommes à votre service.</p>
            <div className="contact-info">
              <h4>Contactez-nous</h4>
              <p><IoTimeOutline /> Lun - Ven: 8:00 - 17:00</p>
              <p><FaPhoneAlt /> +241 11 73 05 51</p>
              <p><IoIosMail /> info@jetagroupe.com</p>
            </div>
            <div className="office-address">
              <h4>Adresse</h4>
              <p>Face tribunal du commerce , sabliére, libreville , Gabon</p>
            </div>
            <div className="spacer"></div> 
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
